import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NO_ERRORS_SCHEMA } from '@angular/core';
import { SharedDatagridRoutingModule } from './shared-datagrid-routing.module';
import { Router } from '@angular/router';
import { SharedDatagridComponent } from './shared-datagrid.component';

import { DxButtonModule, DxDataGridModule, DxPopupModule, DxScrollViewModule, DxSortableModule, DxTemplateModule, DxDropDownButtonModule } from 'devextreme-angular';
import { MdbGlobalModule } from '../mdb-global.module';
import { FormsModule, ReactiveFormsModule,  } from '@angular/forms';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    SharedDatagridComponent
  ],
  imports: [
    CommonModule,
    SharedDatagridRoutingModule,
    MdbGlobalModule,
    DxTemplateModule,
    DxButtonModule,
    DxScrollViewModule,
    DxPopupModule,
    DxDataGridModule,
    DxSortableModule,
    DxDropDownButtonModule
  ],
  exports: [SharedDatagridComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class SharedDatagridModule { 
  
  constructor(private router: Router){ }

  ngOninit(){
  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  ngAfterViewInit(){}
  
}
